import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HostsComponent } from 'src/app/components/hosts/hosts.component';
import { ShipmentDetailsNoHostMiddleComponent } from 'src/app/components/shipment-details-nohost-middle/shipment-details-nohost-middle.component';
import { ShipmentDetailsNoHostComponent } from 'src/app/components/shipment-details-nohost/shipment-details-nohost.component';
import { ShopFromComponent } from 'src/app/components/shop-from/shop-from.component';
import { IsNewUserGuard } from 'src/app/guards/is-new-user.guard';
import { IsShopperGuard } from 'src/app/guards/is-shopper.guard';
import { VerificationGuard } from 'src/app/guards/verification.guard';


// IsNewUserGuard for getaddress-details

const routes: Routes = [
  {
    path: "", component: ShopFromComponent
  },
  {
    path: ":countryCode",component: HostsComponent
  },
  {
    path: ":countryCode/address-details-middleware", component: ShipmentDetailsNoHostMiddleComponent, canActivate: [IsShopperGuard, IsNewUserGuard, VerificationGuard]
  },
  {
    path: ":countryCode/getaddress-details", component: ShipmentDetailsNoHostComponent, canActivate: [IsShopperGuard, IsNewUserGuard, VerificationGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HostsRoutingModule { }
